// Copyright ©️ 2026 eVolve MEP, LLC

export const MARKUP_IMAGE_CONTENT_TYPES = ['image/jpeg', 'image/png'] as const;
export type MarkupImageContentType = (typeof MARKUP_IMAGE_CONTENT_TYPES)[number];

export const FILE_PREVIEW_SUPPORTED_CONTENT_TYPES = ['application/pdf', ...MARKUP_IMAGE_CONTENT_TYPES] as const;
export type FilePreviewSupportedContentType = (typeof FILE_PREVIEW_SUPPORTED_CONTENT_TYPES)[number];
